import { render, staticRenderFns } from "./ApproveLevel2.vue?vue&type=template&id=318364ee&scoped=true"
import script from "./ApproveLevel2.vue?vue&type=script&lang=js"
export * from "./ApproveLevel2.vue?vue&type=script&lang=js"
import style0 from "./ApproveLevel2.vue?vue&type=style&index=0&id=318364ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318364ee",
  null
  
)

export default component.exports